<div class="content-container">
    <nav class="navbar sticky-top">
        <div class="d-grid gap-2 d-flex navbar-brand">
            <button (click)="this.location.back();" type="button" ngbTooltip="Back" placement="bottom" class="btn btn-primary backBtn" aria-label="Back">
                <fa-icon [icon]="faAngleLeft"></fa-icon>
            </button>
            <h2 class="mobileHeading">Payments</h2>
        </div>
        <div class="row ms-auto">
            <div class="col-auto pe-2">
                <app-date-picker-controller #datePickerController componentId="Reports.Payments" preset="YTD" [showButtons]="false" (dateChanged)="dateChanged($event);"  [onLoad]="true"></app-date-picker-controller>
            </div>
            <div class="col-auto my-auto">
                <button type="button" class="btn btn-primary" (click)="downloadReport();">
                    <fa-icon [icon]="faFileDownload"></fa-icon>
                    <span class="d-md-inline ms-2">Export</span>
                </button>
            </div>
        </div>
    </nav>
    <div class="row mt-3">
        <div class="card p-0">
            <div class="card-body">
                <h5 class="card-title">Description</h5>
                <p class="card-text m-0">This report can be used to review payments and volume insights.</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
            <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Volume by Category ({{filteredCategoryTotal | currency}})</h5>
                    <div class="col-auto">
                        <select class="form-select form-select-sm" [(ngModel)]="categoryFilter" (change)="onCategoryFilterChange()">
                            <option *ngFor="let option of categoryFilterOptions" [value]="option.value">{{option.label}}</option>
                        </select>
                    </div>
                </div>
                <div class="card-body" style="height: 500px;">
                    <div style="position: relative; width: auto; height: 468px;">
                        <canvas id="CATEGORY_CHART"></canvas>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
            <div class="card">
                <div class="card-header">
                    <h5>Volume by Month ({{monthlyVolumeTotal | currency}})</h5>
                </div>
                <div class="card-body" style="height: 500px;">
                    <div style="position: relative; width: auto; height: 468px;">
                        <canvas id="MONTHLY_VOLUME_CHART"></canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row button-container mt-2" *ngIf="isMobile">
      <div class="sort"> <ng-container *ngTemplateOutlet="SORT_DROPDOWN"></ng-container></div>
      <div class="filter"><ng-container *ngTemplateOutlet="FILTER_DROPDOWN"></ng-container></div>
    </div>
    <div class="row justify-content-end mt-3">
        <div class="col-md-auto col-12">
            <input
            type="search"
            class="form-control"
            placeholder="Search Payments"
            [value]="storedSearchValue"
            (keyup)="tableControls.search($event.target.value)"
            (search)="tableControls.search($event.target.value)"
            />
        </div>
    </div>


    <div class="row mt-3">
        <div class="col table-responsive">
            <table *ngIf="!isMobile" class="table table-hover">
                <thead>
                    <tr>
                        <!-- Client -->
                        <th (click)="tableControls.sort('c.client_name');">
                            Client
                            <fa-icon *ngIf="tableControls.isSortedBy('c.client_name')" [icon]="(tableControls.isSortedASC() ? faSortDown : faSortUp)" class="sortButton"></fa-icon>
                        </th>
                        <!-- Invoice # -->
                        <th (click)="tableControls.sort('i.invoice_number');">
                            Invoice #
                            <fa-icon *ngIf="tableControls.isSortedBy('i.invoice_number')" [icon]="(tableControls.isSortedASC() ? faSortDown : faSortUp)" class="sortButton"></fa-icon>
                        </th>
                        <!-- Date -->
                        <th (click)="tableControls.sort('pay.payment_date, pay.payment_created_at');">
                            Date
                            <fa-icon *ngIf="tableControls.isSortedBy('pay.payment_date, pay.payment_created_at')" [icon]="(tableControls.isSortedASC() ? faSortDown : faSortUp)" class="sortButton"></fa-icon>
                        </th>
                        <!-- Category -->
                        <th>
                            <div class="d-flex" style="position: relative;">
                                <div class="header-filter-container" [ngbPopover]="popContentFilter" [popoverTitle]="popTitleFilter" triggers="manual" autoClose="outside" #paymentCategory="ngbPopover" (click)="showColumnFilterPopover(paymentCategory, 'pay.payment_category');">
                                    <span *ngIf="tableControls.hasActiveFilter('pay.payment_category')" class="custom-badge">{{tableControls.getColumnActiveFilterCount('pay.payment_category')}}</span>
                                    <fa-icon [icon]="faFilter"></fa-icon>
                                </div>
                                <div class="w-100 px-3" (click)="tableControls.sort('pay.payment_category');">
                                    Category
                                </div>
                                <fa-icon *ngIf="tableControls.isSortedBy('pay.payment_category')" class="header-sort-container" [icon]="(tableControls.isSortedASC() ? faSortDown : faSortUp)"></fa-icon>
                            </div>
                        </th>
                        <th>Amount</th>
                        <!-- Status -->
                        <th>
                            <div class="d-flex" style="position: relative;">
                                <div class="header-filter-container" [ngbPopover]="popContentFilter" [popoverTitle]="popTitleFilter" triggers="manual" autoClose="outside" #paymentStatus="ngbPopover" (click)="showColumnFilterPopover(paymentStatus, 'pay.payment_status');">
                                    <span *ngIf="tableControls.hasActiveFilter('pay.payment_status')" class="custom-badge">{{tableControls.getColumnActiveFilterCount('pay.payment_status')}}</span>
                                    <fa-icon [icon]="faFilter"></fa-icon>
                                </div>
                                <div class="w-100 px-3" (click)="tableControls.sort('pay.payment_status');">
                                    Status
                                </div>
                                <fa-icon *ngIf="tableControls.isSortedBy('pay.payment_status')" class="header-sort-container" [icon]="(tableControls.isSortedASC() ? faSortDown : faSortUp)"></fa-icon>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let payment of payments" (click)="openPaymentModal(payment);">
                        <td data-label="Client">{{payment.clientName}}</td>
                        <td data-label="Invoice #">{{payment.invoiceNumber}}</td>
                        <td data-label="Date">{{payment.date | formatDateTime: true}}</td>
                        <td data-label="Category">{{payment.category | paymentCategory}}</td>
                        <td data-label="Amount">{{payment.amount | currency}}</td>
                        <td data-label="Status">{{payment.status | paymentStatus}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="scrollable" *ngIf="isMobile">
              <ul class="list-group">
                  <li *ngFor="let payment of payments" class="list-group-item list-group-item-action" (click)="openPaymentModal(payment);">
                      <div class="d-flex list-group-container">
                          <div>
                              <strong>{{payment.clientName}}</strong>
                              <div><strong>Invoice #: </strong>{{payment.invoiceNumber}}</div>
                              <div><strong>Date: </strong>{{payment.date | formatDateTime: true}}</div>
                              <div><strong>Category: </strong>{{payment.category | paymentCategory}}</div>
                              <div><strong>Amount: </strong>{{payment.amount | currency}}</div>
                              <div><strong>Status: </strong>{{payment.status | paymentStatus}}</div>
                          </div>
                      </div>
                  </li>
                  <li *ngIf="payments.length == 0" class="list-group-item">No Payments</li>
              </ul>
            </div>
        </div>
    </div>
    <div class="row table-controls">
        <div *ngIf="tableControls.isNotDefault() && !isMobile" class="col-auto mt-3 me-2 me-md-0">
            <button type="button" class="btn btn-outline-danger" (click)="tableControls.resetTableConfiguration();">
                <fa-icon class="button-icon-left" [icon]="faRotateLeft"></fa-icon>
                <span>Reset</span>
            </button>
        </div>
        <div class="col mt-3">
            <div ngbDropdown placement="top-left" class="d-inline-block">
                <button class="btn btn-outline-primary" ngbDropdownToggle><span *ngIf="!isMobile">Page Size: </span> {{tableControls.getLimit()}}</button>
                <div ngbDropdownMenu class="page-size-dropdown" *ngIf="!isMobile">
                  <button ngbDropdownItem (click)="tableControls.setLimit(20);">20</button>
                  <button ngbDropdownItem (click)="tableControls.setLimit(50);">50</button>
                  <button ngbDropdownItem (click)="tableControls.setLimit(100);">100</button>
                </div>
                <div ngbDropdownMenu class="page-size-dropdown" *ngIf="isMobile">
                  <button ngbDropdownItem (click)="tableControls.setLimit(5);">5</button>
                  <button ngbDropdownItem (click)="tableControls.setLimit(10);">10</button>
                  <button ngbDropdownItem (click)="tableControls.setLimit(20);">20</button>
                </div>
            </div>
        </div>
        <div class="col my-3">
            <ngb-pagination class="d-flex justify-content-end" *ngIf="paymentCount > 0" [page]="tableControls.getCurrentPage()" [pageSize]="tableControls.getLimit()" [collectionSize]="paymentCount" [boundaryLinks]="true" [maxSize]="(isMobile) ? 3 : 10" [ellipses]="true" [rotate]="true" (pageChange)="tableControls.setCurrentPage($event);"></ngb-pagination>
        </div>
    </div>
</div>

<!-- Filter -->
<ng-template #popTitleFilter>Filter</ng-template>
<ng-template let-column="column" #popContentFilter>
    <div *ngFor="let element of this.columnFilterValues.get(column)" class="form-check">
        <input [id]="element.randomId" class="form-check-input" type="checkbox" (change)="tableControls.toggleFilter(column, element.value);" [checked]="tableControls.filterExists(column, element.value)">
        <label [for]="element.randomId" class="form-check-label">{{element.name}}</label>
    </div>
</ng-template>

<!-- Sort Dropdown -->
<ng-template #SORT_DROPDOWN>
  <div ngbDropdown class="d-inline-block" [autoClose]="true" placement="bottom-left">
      <button class="btn btn-outline-primary mt-1" ngbDropdownToggle ngbTooltip="Sort">
          <fa-icon [icon]="faSortAmountDownAlt"></fa-icon>
      </button>
      <!-- Sort Options -->
      <div ngbDropdownMenu>
          <button *ngFor="let sort of sortOptions" ngbDropdownItem (click)="sorting(sort.value);">
            {{sort.label}}
            <fa-icon *ngIf="sortBy == sort.value" [icon]="(sortDirection == 'ASC' ? faSortDown : faSortUp)" class="sortButton"></fa-icon>
          </button>
      </div>
  </div>
</ng-template>

<!-- Filter Dropdown -->
<ng-template #FILTER_DROPDOWN>
  <div ngbDropdown class="d-inline-block filter-container" autoClose="outside" placement="bottom-left">
      <span *ngIf="activeFilterCount > 0" class="custom-badge-lg">{{activeFilterCount}}</span>
      <button class="btn btn-outline-primary mt-1" ngbDropdownToggle ngbTooltip="Filter">
          <fa-icon [icon]="faFilter"></fa-icon>
      </button>
      <div ngbDropdownMenu>
          <!-- Filter Options -->
          <div *ngFor="let filter of filterColumns">
            <button ngbDropdownItem class="button-filter" (click)="getDistinctColumnValues(filter.value); filters.toggle();">{{filter.label}}</button>
            <div class="px-4 py-1" #filters="ngbCollapse" [ngbCollapse]="filter.value === selectedFilterColumn ? false : true">
                <div class="d-flex flex-column">
                    <div *ngFor="let element of columnFilterValues.get(filter.value);" class="form-check form-check-inline">
                        <input [id]="element.randomId" class="form-check-input" type="checkbox" (change)="toggleFilter(filter.value, element.value);" [checked]="filterExists(filter.value, element.value)">
                        <label [for]="element.randomId" class="form-check-label" style="white-space: nowrap;">{{element.name}}</label>
                    </div>
                </div>
            </div>
          </div>

          <!-- Divider -->
          <div class="dropdown-divider"></div>
          <!-- Reset -->
          <button class="reset-button" ngbDropdownItem (click)="resetActiveFilters(); selectedFilterColumn = ''">Reset</button>
      </div>
  </div>
</ng-template>
<!-- LOADER -->
<ngx-spinner>
  <p class="loading-spinner">Loading...</p>
</ngx-spinner>
